import React from 'react'

export const ErrorRobot = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="226"
    height="202"
    viewBox="0 0 226 202"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M169.227 59.015C175.433 58.2384 181.145 62.6814 181.918 68.8879L183.298 79.9242C184.075 86.1307 179.632 91.8422 173.425 92.6157"
      fill="#F5F4F2"
    />
    <path
      d="M169.227 59.015C175.433 58.2384 181.145 62.6814 181.918 68.8879L183.298 79.9242C184.075 86.1307 179.632 91.8422 173.425 92.6157"
      stroke="#282421"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M182.28 73.6268L189.096 72.776"
      stroke="#282421"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M53.4314 107.232C47.2249 108.008 41.5133 103.565 40.7398 97.3587L39.3599 86.3224C38.5833 80.1158 43.0263 74.4043 49.2329 73.6308"
      fill="#F5F4F2"
    />
    <path
      d="M53.4314 107.232C47.2249 108.008 41.5133 103.565 40.7398 97.3587L39.3599 86.3224C38.5833 80.1158 43.0263 74.4043 49.2329 73.6308"
      stroke="#282421"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M33.1317 91.8888L39.9508 91.0379"
      stroke="#282421"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M127.706 135.749L106.302 134.432L110.963 179.794L132.368 181.112L127.706 135.749Z"
      fill="white"
      stroke="#282421"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M155.48 34.944L56.4745 47.3109C51.3877 47.9463 47.7791 52.585 48.4145 57.6718L60.0912 151.151C60.7265 156.238 65.3653 159.847 70.452 159.211L169.458 146.844C174.544 146.209 178.153 141.57 177.518 136.483L165.841 43.0039C165.206 37.9172 160.567 34.3086 155.48 34.944Z"
      fill="#F5F4F2"
      stroke="#282421"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M149.783 73.5665C149.783 82.1031 142.863 89.0234 134.327 89.0234C125.79 89.0234 118.87 82.1031 118.87 73.5665C118.87 65.0298 125.79 58.1095 134.327 58.1095C142.863 58.1095 149.783 65.0298 149.783 73.5665Z"
      fill="white"
      stroke="#282421"
      strokeWidth="2"
    />
    <path
      d="M137.083 73.5665C137.083 75.0887 135.849 76.3226 134.327 76.3226C132.804 76.3226 131.57 75.0887 131.57 73.5665C131.57 72.0443 132.804 70.8104 134.327 70.8104C135.849 70.8104 137.083 72.0443 137.083 73.5665Z"
      fill="#FE0072"
      stroke="#282421"
      strokeWidth="2"
    />
    <path
      d="M128.315 24.4845L126.709 11.632C125.904 5.20583 132.343 0.314228 138.318 2.80489L143.314 4.88715"
      stroke="#282421"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M150.468 14.7377C154.261 14.7377 157.336 11.6625 157.336 7.869C157.336 4.07554 154.261 1.00034 150.468 1.00034C146.674 1.00034 143.599 4.07554 143.599 7.869C143.599 11.6625 146.674 14.7377 150.468 14.7377Z"
      fill="#EEF1FA"
      stroke="#282421"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M132.975 23.902L123.655 25.0654C116.818 25.9193 111.966 32.1568 112.82 38.9945C112.907 39.6876 113.535 40.1764 114.228 40.0898L145.811 36.1419C146.505 36.0552 146.993 35.4271 146.907 34.7341C146.053 27.8964 139.815 23.045 132.978 23.8989L132.975 23.902Z"
      fill="#F5F4F2"
      stroke="#282421"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M80.2372 30.4917L78.6315 17.6392C77.827 11.213 70.386 8.05714 65.2066 11.9401L60.8781 15.1888"
      stroke="#282421"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M54.6746 26.7078C58.468 26.7078 61.5432 23.6326 61.5432 19.8391C61.5432 16.0457 58.468 12.9705 54.6746 12.9705C50.8811 12.9705 47.8059 16.0457 47.8059 19.8391C47.8059 23.6326 50.8811 26.7078 54.6746 26.7078Z"
      fill="#EEF1FA"
      stroke="#282421"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M75.5775 31.0736L84.8966 29.9103C91.7343 29.0563 97.9718 33.9077 98.8258 40.7454C98.9124 41.4385 98.4236 42.0666 97.7305 42.1532L66.147 46.1011C65.454 46.1878 64.8259 45.6989 64.7393 45.0059C63.8853 38.1681 68.7367 31.9306 75.5744 31.0767L75.5775 31.0736Z"
      fill="#F5F4F2"
      stroke="#282421"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M86.4684 134.286L95.8247 126.192L106.895 131.733L116.264 123.639L127.337 129.178L136.727 121.081L147.819 126.619"
      stroke="#282421"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M70.7697 69.7429L96.2642 89.5754"
      stroke="#282421"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M93.4331 66.9119L73.6038 92.4064"
      stroke="#282421"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M36.9702 161.71L33.8161 179.963"
      stroke="#FE0072"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M44.5214 172.415L26.2649 169.258"
      stroke="#FE0072"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <line
      x1="225.433"
      y1="200.193"
      x2="-8.74228e-08"
      y2="200.193"
      stroke="#282421"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M66.8467 171.294H166.393C171.516 171.294 175.675 175.452 175.675 180.576V200.306H57.5647V180.576C57.5647 175.452 61.7231 171.294 66.8467 171.294Z"
      fill="#F5F4F2"
      stroke="#282421"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M72.7385 191.856C75.5392 191.856 77.8095 189.586 77.8095 186.785C77.8095 183.985 75.5392 181.714 72.7385 181.714C69.9378 181.714 67.6674 183.985 67.6674 186.785C67.6674 189.586 69.9378 191.856 72.7385 191.856Z"
      fill="#F5F4F2"
      stroke="#282421"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path d="M87.2682 186.785H103.821" stroke="#282421" strokeWidth="2" strokeMiterlimit="10" />
  </svg>
)
